/**
 * Cities we sync and display on /weather.
 * Ashkelon has no dedicated IMS city forecast row - we take the nearest
 * XML location by lat/lon and still label it אשקלון. Observation comes
 * from station 208 (Ashqelon Port) when a token is available.
 * Remaining entries cover every city in the IMS evening cities forecast.
 */
export const WEATHER_CITIES = [
    {
        key: 'ashkelon',
        name: 'אשקלון',
        matchEng: null,
        latitude: 31.668719,
        longitude: 34.574073,
        stationId: 208,
        sortOrder: 0,
        primary: true,
    },
    {
        key: 'ashdod',
        name: 'אשדוד',
        matchEng: 'Ashdod',
        latitude: 31.84,
        longitude: 34.64,
        stationId: null,
        sortOrder: 1,
        primary: false,
    },
    {
        key: 'beer-sheva',
        name: 'באר שבע',
        matchEng: 'Beer Sheva',
        latitude: 31.25,
        longitude: 34.8,
        stationId: null,
        sortOrder: 2,
        primary: false,
    },
    {
        key: 'tel-aviv',
        name: 'תל אביב',
        matchEng: 'Tel Aviv - Yafo',
        latitude: 32.1,
        longitude: 34.76,
        stationId: null,
        sortOrder: 3,
        primary: false,
    },
    {
        key: 'jerusalem',
        name: 'ירושלים',
        matchEng: 'Jerusalem',
        latitude: 31.78,
        longitude: 35.22,
        stationId: null,
        sortOrder: 4,
        primary: false,
    },
    {
        key: 'haifa',
        name: 'חיפה',
        matchEng: 'Haifa',
        latitude: 32.82,
        longitude: 35,
        stationId: null,
        sortOrder: 5,
        primary: false,
    },
    {
        key: 'eilat',
        name: 'אילת',
        matchEng: 'Elat',
        latitude: 29.55,
        longitude: 34.9,
        stationId: null,
        sortOrder: 6,
        primary: false,
    },
    {
        key: 'lod',
        name: 'לוד',
        matchEng: 'Lod',
        latitude: 31.85,
        longitude: 34.9,
        stationId: null,
        sortOrder: 7,
        primary: false,
    },
    {
        key: 'afula',
        name: 'עפולה',
        matchEng: 'Afula',
        latitude: 32.52,
        longitude: 35.25,
        stationId: null,
        sortOrder: 8,
        primary: false,
    },
    {
        key: 'bet-shean',
        name: 'בית שאן',
        matchEng: 'Bet Shean',
        latitude: 32.45,
        longitude: 35.5,
        stationId: null,
        sortOrder: 9,
        primary: false,
    },
    {
        key: 'nazareth',
        name: 'נצרת',
        matchEng: 'Nazareth',
        latitude: 32.75,
        longitude: 35.3,
        stationId: null,
        sortOrder: 10,
        primary: false,
    },
    {
        key: 'tiberias',
        name: 'טבריה',
        matchEng: 'Tiberias',
        latitude: 32.8,
        longitude: 35.53,
        stationId: null,
        sortOrder: 11,
        primary: false,
    },
    {
        key: 'zefat',
        name: 'צפת',
        matchEng: 'Zefat',
        latitude: 33.05,
        longitude: 35.44,
        stationId: null,
        sortOrder: 12,
        primary: false,
    },
    {
        key: 'qazrin',
        name: 'קצרין',
        matchEng: 'Qazrin',
        latitude: 32.98,
        longitude: 35.7,
        stationId: null,
        sortOrder: 13,
        primary: false,
    },
    {
        key: 'en-gedi',
        name: 'עין גדי',
        matchEng: 'En Gedi',
        latitude: 31.42,
        longitude: 35.35,
        stationId: null,
        sortOrder: 14,
        primary: false,
    },
    {
        key: 'mizpe-ramon',
        name: 'מצפה רמון',
        matchEng: 'Mizpe Ramon',
        latitude: 30.61,
        longitude: 34.8,
        stationId: null,
        sortOrder: 15,
        primary: false,
    },
] as const;

export type WeatherCityConfig = (typeof WEATHER_CITIES)[number];

export const PRIMARY_WEATHER_CITY = WEATHER_CITIES[0].key;
